import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import partnerDummyImage from "../../../../../images/partnerDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ReactFancyBox from "react-fancybox";
const Item = ({
  item,
  handleCheckBoxClick,
  isCheck,
  moduleConfig,
  confirmAndDelete,
  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
}) => {
  const getItems = () => {
    let items = [];
    if (item.website) {
      items = [...items, { text: "Website", value: item.website, type: "link" }];
    }
    if (item.phone) {
      items = [...items, { text: "Phone", value: item.phone, type: "phone" }];
    }
    if (item.email) {
      items = [...items, { text: "Email", value: item.email, type: "email" }];
    }
    return items;
  };
  return (
    <Card className="item mb-2">
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">
            {/* <div className="checkboxCol me-2 ms-2 mt-2">
              <input
                type="checkbox"
                id={item._id}
                name={item._id}
                onChange={handleCheckBoxClick}
                checked={isCheck.includes(item._id)}
              />
            </div> */}

            {/* <div className="ms-1 me-2">
              <i className="fas fa-newspaper pt-1 position-relative usericon ">
                {(item.status === "0" || item.status === 0) && (
                  <i className="fas fa-ban position-absolute ms-1 mb-2 banned"></i>
                )}
              </i>
            </div> */}

            <div className="ms-1 me-2 position-relative">




              <>
                {item.logo ? (
                  <div className="logo-small border rounded-circle image-contain">
                    <ReactFancyBox
                      thumbnail={process.env.REACT_APP_BACKEND_URL + "public/" + item.logo}
                      image={process.env.REACT_APP_BACKEND_URL + "public/" + item.logo}
                    />
                  </div>

                ) : (
                  <Image
                    src={partnerDummyImage}
                    width="52px"
                    height="52px"
                    className="border rounded-circle image-contain"
                  />
                )}
              </>

              {item.status === "0" && (
                <i className="fas fa-ban position-absolute banned2"> </i>
              )}
            </div>

            <div className="d-flex  align-items-center ms-1">
              <span className="m-0 text-bold memberName">{item.title}</span>


            </div>
          </div>
        </Card.Title>

        <div class="card-tools mb-1">
          <div>
            {item.isPromoted === "1" &&
              <span className="badge badge-info me-1 pt-0">
                Promoted
              </span>}
            <span className="badge badge-light me-1 pt-0 text-dark">
              Status :{" "}
              <span class="text-secondary">
                <ModuleDisplayBoolean
                  value={item.status}
                  trueValue="Enabled"
                  falseValue="Disabled"
                />{" "}
              </span>
            </span>

            <span class="badge badge-light me-1 pt-0 text-dark">
              Created Date :{" "}
              <span class="text-secondary">
                <ModuleDisplayDate value={item.createdAt} />{" "}
              </span>
            </span>
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title={`View ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-eye"></i>
            </Link>

            <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`Update ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            <span
              title="Delete Item"
              onClick={() => confirmAndDelete(item._id)}
              className="btn btn-outline-secondary listingActionIcon"
            >
              <i className="fas fa-trash"></i>
            </span>

            {(item.status === "1" || item.status === 1) && (
              <span
                title={`Disabled ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title={`Enabled ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}
          </div>
        </div>
      </Card.Header>
      {getItems().length > 0 &&
        <Card.Body className="px-1 py-0">
          <Row>
            <Col className="mt-1 mb-1 ">

              <StatsListing items={getItems()} />
            </Col>
          </Row>
        </Card.Body>}
    </Card>
  );
};

export default Item;
